const MODAL_DATA_EVENT_NAME = 'modal';
const pushModalDataEvent = (dataEvent) => {
    const modalEvent = {
        event: MODAL_DATA_EVENT_NAME,
        ...dataEvent,
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(modalEvent);
};
export default pushModalDataEvent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHVzaERhdGFsYXllckV2ZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vQGVpa2EvbW9kYWwvc3JjL3V0aWwvcHVzaERhdGFsYXllckV2ZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1BLE1BQU0scUJBQXFCLEdBQUcsT0FBTyxDQUFDO0FBZXRDLE1BQU0sa0JBQWtCLEdBQUcsQ0FBQyxTQUF5QixFQUFFLEVBQUU7SUFDckQsTUFBTSxVQUFVLEdBQWU7UUFDM0IsS0FBSyxFQUFFLHFCQUFxQjtRQUM1QixHQUFHLFNBQVM7S0FDZixDQUFDO0lBRUYsTUFBTSxDQUFDLFNBQVMsR0FBRyxNQUFNLENBQUMsU0FBUyxJQUFJLEVBQUUsQ0FBQztJQUMxQyxNQUFNLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQztBQUN0QyxDQUFDLENBQUM7QUFFRixlQUFlLGtCQUFrQixDQUFDIn0=